import { Modal, Button } from "antd";
import { ContainerButton } from "../styles";
import { validateToken } from "../../../components/Globais";

export default function ModalAcoes({
  isModalOpen,
  handleFechar,
  onClick,
  data,
}: any) {
  const isAdmin = validateToken()?.nda ?? 0;

  const actionButtons =
    isAdmin >= 1
      ? [
          { key: "1", label: "Baixar" },
          { key: "2", label: "Autenticar" },
          { key: "3", label: "Excluir" },
          { key: "4", label: "Bloquear exclusão" },
        ]
      : [
          { key: "1", label: "Baixar" },
          { key: "3", label: "Excluir" },
        ];

  const handleButtonClick = (key: string) => {
    const params: any = { key };

    params.arquivoId = data.arquivoId;
    params.arquivoCotaUsuarioId = data.arquivoCotaUsuarioId;
    params.podeExcluir = data.podeExcluir;

    onClick(params);
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Ações Disponíveis"
      footer={null}
    >
      <ContainerButton>
        {actionButtons.map((btn) => (
          <Button
            key={btn.key}
            style={{ margin: "5px 0", width: "100%" }}
            onClick={() => handleButtonClick(btn.key)}
          >
            {btn.label}
          </Button>
        ))}
      </ContainerButton>
    </Modal>
  );
}
